import { LoadingPaperProps } from './LoadingPaper.props';
import { StyledCircularProgress, StyledLoadingMessage, StyledPaper } from './LoadingPaper.styles';

const LoadingPaper = ({ loading = true, isFullScreen = false, message }: LoadingPaperProps) => (
  <StyledPaper elevation={1} isFullScreen={isFullScreen} loading={loading}>
    <StyledCircularProgress isFullScreen={isFullScreen} />
    {message && (
      <StyledLoadingMessage color="textPrimary" variant="body1">
        {message}
      </StyledLoadingMessage>
    )}
  </StyledPaper>
);

export default LoadingPaper;
